/* Oídos Felices · vidriera. Product picker, sticky bar and partnerships carousel. */
(function () {
  function money(cents) {
    var value = cents / 100;
    return '$' + value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function initProduct(root) {
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var submit = root.querySelector('[data-of-submit]');
    var submitLabel = root.querySelector('[data-of-submit-label]');
    var dynamic = root.querySelector('[data-of-dynamic]');
    var stage = root.querySelector('[data-of-stage]');
    var thumbs = root.querySelectorAll('[data-of-thumb]');
    var selected = root.querySelector('[data-of-selected]');
    var stickyLabel = document.querySelector('[data-of-sticky-label]');
    var stickyPrice = document.querySelector('[data-of-sticky-price]');
    var discount = parseFloat(root.dataset.transferDiscount || '25') / 100;
    var installments = parseInt(root.dataset.installments || '3', 10);
    var labels = { add: root.dataset.labelAdd, soldOut: root.dataset.labelSoldOut };

    function showMedia(src, alt) {
      if (!src || !stage) return;
      stage.src = src;
      stage.alt = alt || '';
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.src === src ? 'true' : 'false'); });
    }

    function select(chip) {
      root.querySelectorAll('.of-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      root.querySelectorAll('.of-tile').forEach(function (t) { t.classList.toggle('is-on', t.contains(chip)); });

      var price = parseInt(chip.dataset.price, 10);
      var available = chip.dataset.available === 'true';
      idInput.value = chip.dataset.variantId;
      idInput.disabled = !available;
      submit.disabled = !available;
      submitLabel.textContent = available ? labels.add : labels.soldOut;
      if (dynamic) dynamic.hidden = !available;

      var transfer = Math.round(price * (1 - discount));
      root.querySelector('[data-of-price]').textContent = money(price);
      root.querySelector('[data-of-installments]').textContent = installments + ' cuotas sin interés de ' + money(Math.round(price / installments));
      root.querySelector('[data-of-transfer]').textContent = money(transfer);
      root.querySelector('[data-of-saving]').textContent = 'Ahorrás ' + money(price - transfer);

      if (selected) selected.textContent = chip.dataset.label;
      if (stickyLabel) stickyLabel.textContent = chip.dataset.label;
      if (stickyPrice) stickyPrice.textContent = money(price);
      showMedia(chip.dataset.media, chip.dataset.label);
    }

    root.querySelectorAll('.of-chip').forEach(function (chip) {
      chip.addEventListener('click', function () { select(chip); });
    });
    // Toda la tarjeta elige: si no se tocó un talle, toma el mismo talle que estaba elegido, o M, o el primero con stock.
    root.querySelectorAll('.of-tile').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (e.target.closest('.of-chip, a')) return;
        var chips = Array.prototype.slice.call(tile.querySelectorAll('.of-chip'));
        if (!chips.length || tile.querySelector('.of-chip[aria-pressed="true"]')) return;
        var current = root.querySelector('.of-chip[aria-pressed="true"]');
        var size = current ? current.textContent.trim() : '';
        var ok = chips.filter(function (c) { return c.dataset.available === 'true'; });
        var pick = ok.filter(function (c) { return c.textContent.trim() === size; })[0]
          || ok.filter(function (c) { return c.textContent.trim() === 'M'; })[0]
          || ok[0] || chips[0];
        select(pick);
      });
    });
    // Miniatura -> selecciona el modelo de esa foto (mismo talle si existe en ese color).
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var matches = Array.prototype.slice.call(root.querySelectorAll('.of-chip[data-media-id="' + t.dataset.mediaId + '"]'));
        if (matches.length) {
          var current = root.querySelector('.of-chip[aria-pressed="true"]');
          var size = current ? current.textContent.trim() : '';
          var pick = matches.filter(function (c) { return c.textContent.trim() === size; })[0] || matches.filter(function (c) { return c.dataset.available === 'true'; })[0] || matches[0];
          select(pick);
        } else {
          showMedia(t.dataset.src, t.dataset.alt);
        }
      });
    });
    var initial = root.querySelector('.of-chip[aria-pressed="true"]') || root.querySelector('.of-chip:not(.is-out)');
    if (initial) select(initial);

    var sticky = document.querySelector('[data-of-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(submit);
      sticky.querySelector('button').addEventListener('click', function () { submit.click(); });
    }
  }

  function initPartners(section) {
    var track = section.querySelector('.of-partners__track');
    var count = section.querySelector('.of-partners__count');
    if (!track) return;
    var n = track.children.length;
    var pages = Math.ceil(n / 3);
    var page = 0;
    var timer = null;
    for (var i = n; i < pages * 3; i++) track.appendChild(track.children[i - n].cloneNode(true));
    function pad(v) { return String(v).padStart(2, '0'); }
    function go(k) {
      page = (k + pages) % pages;
      track.style.transform = 'translateX(' + (-100 * page) + '%)';
      if (count) count.textContent = pad(page + 1) + ' / ' + pad(pages);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      if (pages < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = setInterval(function () { go(page + 1); }, parseInt(section.dataset.interval || '2800', 10));
    }
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    go(0);
    start();
  }


  // Reubica el bloque de Essential Upsell (lo inyecta dentro del formulario de compra) a su propio espacio, más abajo.
  function initUpsell() {
    var slot = document.querySelector('[data-of-upsell-slot]');
    var form = document.querySelector('[data-of-product] form[data-type="add-to-cart-form"]');
    if (!slot || !form) return;
    var body = slot.querySelector('[data-of-upsell-body]');
    function move() {
      var w = form.querySelector('[data-essential-upsell-element]');
      if (w && w.parentNode !== body) { body.appendChild(w); slot.hidden = false; }
    }
    move();
    new MutationObserver(move).observe(form, { childList: true, subtree: true });
  }

  // El badge de Judge.me arriba del título lee datos cacheados de otra ficha; lo igualamos al widget de reseñas de la página (total del grupo).
  function syncRating() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var widget = document.querySelector('.jdgm-rev-widg[data-number-of-reviews]');
      var badges = document.querySelectorAll('.of-buy__rating .jdgm-prev-badge');
      if (widget && badges.length) {
        var n = parseInt(widget.getAttribute('data-number-of-reviews'), 10);
        var avg = widget.getAttribute('data-average-rating');
        badges.forEach(function (b) {
          if (!n) return;
          b.setAttribute('data-number-of-reviews', n);
          if (avg) b.setAttribute('data-average-rating', avg);
          var text = b.querySelector('.jdgm-prev-badge__text');
          if (text) text.textContent = n.toLocaleString('es-AR') + ' reseñas';
        });
        clearInterval(timer);
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  function init() {
    syncRating();
    document.querySelectorAll('[data-of-product]').forEach(initProduct);
    document.querySelectorAll('[data-of-partners]').forEach(initPartners);
    initUpsell();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
